import React, { PureComponent } from "react";
import { Chart } from "@sw/ui-kit";

export default class HprChart extends PureComponent {
  render() {
    return <Chart data={this.props.data} beginAnywhere min={0} max={30} />;
  }
}
